import { CLASSES } from '../utils/constants';
import { toggleHtmlClass } from '../utils/domHelpers';

export function applyUnderlineLinks(enabled) {
  toggleHtmlClass(CLASSES.underlineLinks, enabled);
}
